// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_container__12kx_","socials":"footer_socials__n3d1C","terms":"footer_terms__3grKT","footerHome":"footer_footerHome__2Oh67"};